// Minimal Markdown -> HTML converter for AI generated documents.
export function renderMarkdown(md) {
  if (!md) return "";
  const esc = (s) =>
    s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

  const lines = md.split("\n");
  let html = "";
  let inList = false;
  let listType = "ul";
  let tableBuffer = [];

  const inline = (t) =>
    esc(t)
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/\*(.+?)\*/g, "<em>$1</em>")
      .replace(/`(.+?)`/g, "<code>$1</code>");

  const flushList = () => {
    if (inList) {
      html += `</${listType}>`;
      inList = false;
    }
  };

  const flushTable = () => {
    if (tableBuffer.length) {
      const rows = tableBuffer.filter((r) => !/^\s*\|?[\s:|-]+\|?\s*$/.test(r));
      html += '<table><tbody>';
      rows.forEach((r, idx) => {
        const cells = r.split("|").map((c) => c.trim()).filter((c, i, arr) => !(i === 0 && c === "") && !(i === arr.length - 1 && c === ""));
        const tag = idx === 0 ? "th" : "td";
        html += "<tr>" + cells.map((c) => `<${tag}>${inline(c)}</${tag}>`).join("") + "</tr>";
      });
      html += "</tbody></table>";
      tableBuffer = [];
    }
  };

  for (let raw of lines) {
    const line = raw.replace(/\r$/, "");
    if (line.includes("|") && line.trim().startsWith("|")) {
      flushList();
      tableBuffer.push(line);
      continue;
    } else {
      flushTable();
    }

    if (/^###\s+/.test(line)) { flushList(); html += `<h3>${inline(line.replace(/^###\s+/, ""))}</h3>`; }
    else if (/^##\s+/.test(line)) { flushList(); html += `<h2>${inline(line.replace(/^##\s+/, ""))}</h2>`; }
    else if (/^#\s+/.test(line)) { flushList(); html += `<h1>${inline(line.replace(/^#\s+/, ""))}</h1>`; }
    else if (/^\s*[-*]\s+/.test(line)) {
      if (!inList || listType !== "ul") { flushList(); html += "<ul>"; inList = true; listType = "ul"; }
      html += `<li>${inline(line.replace(/^\s*[-*]\s+/, ""))}</li>`;
    } else if (/^\s*\d+\.\s+/.test(line)) {
      if (!inList || listType !== "ol") { flushList(); html += "<ol>"; inList = true; listType = "ol"; }
      html += `<li>${inline(line.replace(/^\s*\d+\.\s+/, ""))}</li>`;
    } else if (line.trim() === "") {
      flushList();
    } else {
      flushList();
      html += `<p>${inline(line)}</p>`;
    }
  }
  flushList();
  flushTable();
  return html;
}
